module.exports = __webpack_public_path__ + "static/what-we-do-special-projects-5b621029152a72b4cfb4843cf6d94e56.jpg";